module.exports = __webpack_public_path__ + "img/card-info.beeb850c.png";